var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}}),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('BarChart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }